/*
 * humo-where-to-buy.js — Humo Commerce
 * Страница «Где купить» (sections/humo-where-to-buy.liquid):
 *  - фильтр точек по типу (чипы) и городу (select);
 *  - кнопка «На карте» переключает виджет Яндекс.Карт на выбранную точку.
 * Без JS весь список виден, карта показывает первую точку.
 */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 989px)';

  function init(root) {
    if (root.dataset.humoWtbReady) return;
    root.dataset.humoWtbReady = 'true';

    var chips = root.querySelectorAll('[data-kind-filter]');
    var citySelect = root.querySelector('[data-city-filter]');
    var items = root.querySelectorAll('[data-kind]');
    var groups = root.querySelectorAll('[data-group]');
    var empty = root.querySelector('[data-empty]');
    var mapFrame = root.querySelector('[data-map-frame]');
    var mapBox = root.querySelector('[data-map]');

    var state = { kind: 'all', city: '' };

    function matches(item) {
      var kindOk = state.kind === 'all' || item.dataset.kind === state.kind;
      // Онлайн-партнёры без города доступны везде
      var itemCity = item.dataset.city || '';
      var cityOk = !state.city || !itemCity || itemCity === state.city;
      return kindOk && cityOk;
    }

    function apply() {
      var visibleTotal = 0;

      items.forEach(function (item) {
        var visible = matches(item);
        item.hidden = !visible;
        if (visible) visibleTotal += 1;
      });

      groups.forEach(function (group) {
        group.hidden = !group.querySelector('[data-kind]:not([hidden])');
      });

      if (empty) empty.hidden = visibleTotal > 0;

      // Карта показывает первую видимую точку с адресом
      var firstVisible = root.querySelector('[data-map-src]:not([hidden])');
      if (firstVisible) showOnMap(firstVisible, false);
    }

    function showOnMap(card, scroll) {
      if (!mapFrame) return;

      var src = card.dataset.mapSrc;
      if (src && mapFrame.getAttribute('src') !== src) {
        mapFrame.setAttribute('src', src);
      }

      root.querySelectorAll('.humo-wtb__card.is-active').forEach(function (active) {
        active.classList.remove('is-active');
      });
      card.classList.add('is-active');

      if (scroll && mapBox && window.matchMedia(MOBILE_QUERY).matches) {
        mapBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        state.kind = chip.dataset.kindFilter;
        chips.forEach(function (other) {
          var active = other === chip;
          other.classList.toggle('is-active', active);
          other.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        apply();
      });
    });

    if (citySelect) {
      citySelect.addEventListener('change', function () {
        state.city = citySelect.value;
        apply();
      });
    }

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-show-on-map]');
      if (!button) return;
      var card = button.closest('[data-map-src]');
      if (card) showOnMap(card, true);
    });

    var firstCard = root.querySelector('[data-map-src]');
    if (firstCard && mapFrame) firstCard.classList.add('is-active');
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-humo-wtb]').forEach(init);
  }

  initAll(document);

  // Редактор темы перерисовывает секцию целиком
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
